import { useMutation } from "@apollo/client";
import { UpdateDisbursementMutation, UpdateDisbursementMutationVariables } from "generated/graphql";
import mutations from "Shared/mutations";

export const useUpdateDisbursement = () => {
  const [updateDisbursementMutation] = useMutation<UpdateDisbursementMutation, UpdateDisbursementMutationVariables>(
    mutations.UPDATE_DISBURSEMENT,
  );

  const updateDisbursement = async (
    approved: boolean,
    disbursementId: string
  ) => {
    const response = await updateDisbursementMutation({
      variables: {
        approved,
        disbursementId,
      },
    });

    return response;
  };

  return { updateDisbursement };
};
